import { Embroidery, State } from 'src/types'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery,
  bottomRightOfBeltEmbroidery,
  sideOfLabelEmbroidery
} from 'src/features/brands/ragdelion/canvas/common/back/embroidery'
import { ragLabelColorObjs } from '../../../constants/colors'
import { coreLine, hollowOutOfLabel, labelBase } from '../../labels/ragdelion'

const liningEmbroideryObject = {
  first: {
    x: 110,
    y: -75,
    position: 'leatherLiningFirst'
  },
  second: {
    x: 115,
    y: -30,
    position: 'leatherLiningSecond'
  }
}

export const liningEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const isEmbroideryOfLining = embroideries?.some((x) => x.position.value === liningEmbroideryObject[step].position)
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === liningEmbroideryObject[step].position),
      liningEmbroideryObject[step].x,
      liningEmbroideryObject[step].y,
      fontSize
    )
  }
}

export const thumbEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -115,
      30,
      -15
    )
}

export const pitcherThumbRightEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFingerRight')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFingerRight'),
      -75,
      30,
      -15
    )
}

export const pitcherThumbLeftEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFingerLeft')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFingerLeft'),
      220,
      -140,
      32
    )
}

export const firstBackThumbRightEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFingerRight')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFingerRight'),
      -25,
      20,
      -13
    )
}

export const firstBackThumbLeftEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFingerLeft')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFingerLeft'),
      240,
      -127,
      28
    )
}

// export type Embroidery = {
//   id: number
//   typeFace: StateObj
//   position: StateObj
//   color: StateObj
//   shadowColor: StateObj
//   edgeColor: StateObj
//   content: string
// }

const nonThumbEmbroideryObject = {
  middleFinger: {
    x: -140,
    y: -190,
    numerator: 5
  },
  ringFinger: {
    x: -60,
    y: -80,
    numerator: -5
  },
  childFinger: {
    x: -70,
    y: -45,
    numerator: -2
  }
}

export const nonThumbEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === fingerType)
  if (isEmbroideryDraw) {
    notThumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === fingerType),
      nonThumbEmbroideryObject[fingerType].x,
      nonThumbEmbroideryObject[fingerType].y,
      nonThumbEmbroideryObject[fingerType].numerator
    )
  }
}

export const bottomRightOfBeltEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'belt'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    bottomRightOfBeltEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

export const sideOfLabelEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'sideOfLabel'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    sideOfLabelEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

// export const circleHollowOutEmbroideryDrawer = (
//   ctx: CanvasRenderingContext2D,
//   embroideries: Embroidery[]
// ) => {
//   const filterFunction = (x: Embroidery) => x.position.value === 'circleHollowOut'
//   const isEmbroideryOfCircleHollowOut = embroideries.some(filterFunction)
//   if (isEmbroideryOfCircleHollowOut) {
//     circleHollowOutEmbroidery(ctx, embroideries.find(filterFunction), 0, 0)
//   }
// }

// eslint-disable-next-line
export const isHalfWidthCharChecker = (str: string) => !str.match(/^[^\x01-\x7E\xA1-\xDF]+$/)

export const ragLogoDrawer = (ctx: CanvasRenderingContext2D, state: State, x: number, y: number, numerator: number, scaleSize: number) => {
  const existsRagLogo = state.ragLogo?.value === 'ragLogo'
  if (existsRagLogo) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
    ctx.scale(scaleSize, scaleSize)
    coreLine(ctx, state.ragLogoColor.color || '#eee', x, y)
    hollowOutOfLabel(ctx, state.middleIndex.color || '#eee', x, y)
    ctx.restore()
  }
}
